import React from 'react';

/** Libby theme palette — pink, orange, purple, teal, gold */
const THEME_COLORS = [
  '#f25a94',
  '#ffb24a',
  '#d964e6',
  '#3ecfc4',
  '#ffd93d',
  '#d9468f',
  '#e8a5f5',
  '#2fb0a6',
];

const SHAPES = ['star', 'spark', 'dot', 'diamond'];

/** Particles burst from center to the full hero panel (vmin so they reach edges). */
const EXPLOSION_PARTICLES = Array.from({ length: 96 }, (_, i) => {
  const angle = (i / 96) * 360 + ((i * 13) % 31);
  const rad = (angle * Math.PI) / 180;
  const ring = i % 6;
  const distVmin = 14 + ring * 11 + (i % 8) * 4.5;
  return {
    id: i,
    shape: SHAPES[i % SHAPES.length],
    color: THEME_COLORS[i % THEME_COLORS.length],
    sx: `${(Math.cos(rad) * distVmin).toFixed(2)}vmin`,
    sy: `${(Math.sin(rad) * distVmin).toFixed(2)}vmin`,
    size: 4 + (i % 7) + (i % 4),
    delay: (i % 9) * 0.014 + (i % 5) * 0.006,
    rotate: (i * 23) % 360,
  };
});

export default function HeroStarExplosion() {
  return (
    <div className="hero-star-explosion" aria-hidden>
      <span className="hero-star-explosion__curtain" />
      <span className="hero-star-explosion__clearing" />
      <div className="hero-star-explosion__stage">
        <span className="hero-star-explosion__seed" />
        <span className="hero-star-explosion__bloom" />
        <span className="hero-star-explosion__bloom hero-star-explosion__bloom--outer" />
      </div>
      <div className="hero-star-explosion__particles">
        {EXPLOSION_PARTICLES.map(p => (
          <span
            key={p.id}
            className={`hero-star-explosion__particle hero-star-explosion__particle--${p.shape}`}
            style={{
              '--sx': p.sx,
              '--sy': p.sy,
              '--star-color': p.color,
              '--star-size': `${p.size}px`,
              '--star-delay': `${p.delay}s`,
              '--star-rotate': `${p.rotate}deg`,
            }}
          />
        ))}
      </div>
    </div>
  );
}
